import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Roles } from "../types/roles";
import { useAppSelector } from "./useAppSelector";

type AccessConfig = Partial<Record<Roles, string[]>>;

export const useRestrictAccess = (config: AccessConfig): void => {
    const user = useAppSelector((state) => state.user.user);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!user) return;

        const matchedRole = user.roles.find((role): role is Roles =>
            Object.values(Roles).includes(role as Roles)
        );

        if (!matchedRole) return;

        const allowedPaths = config[matchedRole];

        if (!allowedPaths) return;

        const isAllowed = allowedPaths.some((path) =>
            location.pathname.startsWith(path)
        );

        if (!isAllowed) {
            navigate(allowedPaths[0], { replace: true });
        }
    }, [user?.roles, location.pathname, navigate, config]);
};
